module.exports = __webpack_public_path__ + "media/images/icons/filled/slack-circle-48fea60f476631f0553226116c09702e.svg";